import React from 'react';
import { Header } from './components/Header';
import { WarningSigns } from './components/WarningSigns';
import { WhyItMatters } from './components/WhyItMatters';
import { Solution } from './components/Solution';
import { Science } from './components/Science';
import { Timeline } from './components/Timeline';
import { Founder } from './components/Founder';
import { Testimonials } from './components/Testimonials';
import { DosageGuide } from './components/DosageGuide';
import { Checklist } from './components/Checklist';
import { ProductDetails } from './components/ProductDetails';
import { SpecialOffer } from './components/SpecialOffer';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="w-full bg-amber-50 font-sans" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />
      <WarningSigns data-id="element-3" />
      <WhyItMatters data-id="element-4" />
      <Solution data-id="element-5" />
      <Science data-id="element-6" />
      <Timeline data-id="element-7" />
      <Founder data-id="element-8" />
      <Testimonials data-id="element-9" />
      <DosageGuide data-id="element-10" />
      <Checklist data-id="element-11" />
      <ProductDetails data-id="element-12" />
      <SpecialOffer data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}